import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import RadioGroup from '../RadioGroup';
import Radio from '../Radio';
import styled, { css } from 'styled-components';
import { STATUS_ERROR, STATUS_VALID } from '@g4/form';

const labelStyles = css`
  font-size: 0.75rem;
  font-weight: bold;
  padding: 0 10px; /* Provide larger surface area for touch */
`;

export const RadioComponent = styled(Radio)`
  ${labelStyles};
  color: ${props => props.theme.colors.modern.radioGroup.labelUnchecked};

  ${props =>
    props.checked &&
    !props.disabled &&
    css`
      color: ${props.theme.colors.modern.radioGroup.labelChecked};
    `};
`;

/** @visibleName Labelled Radio Group */
export class LabelledRadioGroup extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.string,
    error: PropTypes.bool,
    newError: PropTypes.bool,
    onErrorStatusChange: PropTypes.func,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    error: false,
    onErrorStatusChange: Function.prototype,
    disabled: false,
  };

  UNSAFE_componentWillReceiveProps({ newError }) {
    if (newError !== this.props.error) {
      this.props.onErrorStatusChange(newError ? STATUS_ERROR : STATUS_VALID);
    }
  }

  constructor(props) {
    super(props);

    this.toRef = this.toRef.bind(this);
  }

  //this is necessary for the guiding messages
  toRef(el) {
    this.el = el;
  }

  render() {
    return (
      <RadioGroup {...this.props} toRef={this.toRef}>
        {React.Children.map(this.props.children, radio => {
          return (
            <RadioComponent
              {...radio.props}
              direction="column"
              checkedIconAltAttribute={radio.props.checkedIconAltAttribute}
              disabled={this.props.disabled}
            />
          );
        })}
      </RadioGroup>
    );
  }
}

export default styled(LabelledRadioGroup)`
  display: flex;
  flex: 1;
  flex-shrink: 0;
  justify-content: space-around;
  background-color: #fff;
  box-shadow: inset -1px 0 0 0 ${props => props.theme.colors.modern.radioGroup.border},
    inset 1px 0 0 0 ${props => props.theme.colors.modern.radioGroup.border},
    inset 0 1px 0 0 ${props => props.theme.colors.modern.radioGroup.border},
    inset 0 5px 10px 0 ${props => props.theme.colors.modern.radioGroup.shadow},
    0 1px 0 0 ${props => props.theme.colors.modern.radioGroup.border};

  ${props =>
    props.error &&
    css`
      background-color: ${props.theme.colors.modern.radioGroup.error};
    `};
  ${props =>
    props.disabled &&
    css`
      background-color: ${props.theme.colors.modern.radioGroup.disabled};
    `};
`;
